/* Local estimate only. Formal enquiries use Shopify's native contact form. */
if (!customElements.get('miyolly-order-estimator')) {
  customElements.define('miyolly-order-estimator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const q = (selector) => this.querySelector(selector);
      const fields = [...this.querySelectorAll('[data-estimate]')];
      const get = (name) => q(`[data-estimate="${name}"]`);
      const accept = q('[data-estimate-accept]');
      const next = q('[data-estimate-continue]');
      const enquiry = q('#my-enquiry');
      const summary = q('#my-estimate-summary');
      const returned = Boolean(q('[data-estimate-return]'));
      const key = `miyolly-estimate-v1:${location.pathname}`;
      const options = ['design', 'fabric', 'processing', 'deadline', 'date'];
      const persist = () => {
        try { sessionStorage.setItem(key, JSON.stringify(Object.fromEntries(options.map(name => [name, get(name).value])))); } catch (_) { /* Storage may be disabled. */ }
      };
      // Store only estimate choices, never names, email addresses or enquiry text.
      if (returned) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(key) || '{}');
          options.forEach(name => {
            const field = get(name);
            if (name === 'date' && /^\d{4}-\d{2}-\d{2}$/.test(saved[name] || '')) field.value = saved[name];
            else if ([...field.options || []].some(option => option.value === saved[name])) field.value = saved[name];
          });
        } catch (_) { /* Keep the server response visible without storage. */ }
      }
      const update = (reset) => {
        const pending = get('fabric').value === 'unknown';
        const amount = Number(get('design').value) + (pending ? 0 : Number(get('fabric').value));
        const money = '¥' + amount.toLocaleString('en-US');
        q('[data-estimate-amount]').textContent = q('[data-estimate-amount]').dataset.format.replace('__AMOUNT__', money);
        q('[data-estimate-pending]').hidden = !pending;
        q('[data-estimate-date-wrap]').hidden = get('deadline').value === 'none';
        q('[data-estimate-date-note]').hidden = get('deadline').value === 'none';
        const lines = fields.filter(field => field.tagName === 'SELECT').map(field => field.closest('label').childNodes[0].textContent.trim() + ': ' + field.selectedOptions[0].textContent.trim());
        if (get('deadline').value !== 'none' && get('date').value) lines.push(get('date').closest('label').childNodes[0].textContent.trim() + ': ' + get('date').value);
        lines.push(q('[data-estimate-result] p').textContent.trim() + ': ' + q('[data-estimate-amount]').textContent);
        if (pending) lines.push(q('[data-estimate-pending]').textContent.trim());
        lines.push(q('[data-estimate-exclusions]').textContent.trim(), q('[data-estimate-time]').textContent.trim());
        if (get('deadline').value !== 'none') lines.push(q('[data-estimate-date-note]').textContent.trim());
        if (summary) summary.value = lines.join('\n');
        if (reset) {
          accept.checked = false;
          next.disabled = true;
          // Preserve a Shopify success/error response even when selections change.
          if (!returned) enquiry.hidden = true;
          q('[data-estimate-review]').hidden = false;
        }
        persist();
      };
      fields.forEach(field => field.addEventListener('change', () => update(true)));
      accept.addEventListener('change', () => {
        next.disabled = !accept.checked;
        if (!accept.checked && !returned) enquiry.hidden = true;
      });
      next.addEventListener('click', () => {
        if (!accept.checked) return;
        enquiry.hidden = false;
        q('[data-estimate-review]').hidden = true;
        enquiry.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        enquiry.querySelector('input[autocomplete="name"]')?.focus({ preventScroll: true });
      });
      const contactForm = enquiry?.querySelector('form');
      const messageField = contactForm?.querySelector('textarea[name="contact[body]"]');
      contactForm?.addEventListener('submit', () => {
        if (!messageField || !summary?.value || messageField.value.includes('CUSTOM ORDER ESTIMATE')) return;
        messageField.value = `${messageField.value.trim()}\n\nCUSTOM ORDER ESTIMATE\n${summary.value}`.trim();
      });
      q('[data-estimate-result]').hidden = false;
      q('[data-estimate-gate]').hidden = false;
      if (summary) q('[data-estimate-summary-label]').hidden = false;
      enquiry.hidden = !returned;
      update(false);
    }
  });
}
